export default "__VITE_ASSET__Bo$$vT5___"